import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/money/refund/`;
const PROFILE_URL = `${BACKEND_URL}/api/customerprofile/`;

const getList = async (shop) => {
  return await axios.post(API_URL + 'list', { shop });
};

const create = async (data) => {
  return await axios.post(API_URL + 'create', data);
};

const updateBankInfo = async (id, bankInfo) => {
  return await axios.put(API_URL + 'bank-info', { id, ...bankInfo });
};

const uploadBankQr = async (id, formData) => {
  return await axios.post(API_URL + `${id}/bank-qr`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

const markCustomerNotified = async (id) => {
  return await axios.post(API_URL + `${id}/mark-notified`);
};

const revertToPending = async (id) => {
  return await axios.post(API_URL + `${id}/revert`);
};

const claimRefund = async (id, takeover = false) => {
  return await axios.post(API_URL + `${id}/claim`, { takeover });
};

const releaseRefund = async (id) => {
  return await axios.post(API_URL + `${id}/release`);
};

const getPendingReceiptCounts = async (shop) => {
  return await axios.post(API_URL + 'pending-receipt-counts', { shop });
};

const getReport = async (shop) => {
  return await axios.post(API_URL + 'report', { shop });
};

const searchByUrl = async (url, shop, customerId) => {
  return await axios.post(API_URL + 'search-by-url', { url, shop, ...(customerId && { customerId }) });
};

// Soft-delete a refund; reason is required so a mistaken deletion can be audited.
const deleteRefund = async (id, reason) => {
  return await axios.post(API_URL + `${id}/delete`, { reason });
};

// Edit the refund amount (allowed before the money moves only).
const updateAmount = async (id, amount) => {
  return await axios.post(API_URL + `${id}/amount`, { amount });
};

// Customer changed their mind: keep the refund as store credit instead of transferring.
// Credits advanceAmount and closes the refund (allowed before the money moves only).
const convertToCredit = async (id, note) => {
  return await axios.post(API_URL + `${id}/keep-as-credit`, note ? { note } : {});
};

// Trace the whole refund flow (live + deleted) for an order URL.
const searchFlow = async (url, shop) => {
  return await axios.post(API_URL + 'search-flow', { url, shop });
};

const searchCustomer = async (smileName, shop) => {
  return await axios.post(PROFILE_URL + 'bysmile', {
    smileName,
    includeOrders: false,
    shop,
  });
};

const RefundTransferService = {
  getList,
  create,
  updateBankInfo,
  uploadBankQr,
  revertToPending,
  claimRefund,
  releaseRefund,
  getPendingReceiptCounts,
  markCustomerNotified,
  getReport,
  searchByUrl,
  deleteRefund,
  updateAmount,
  convertToCredit,
  searchFlow,
  searchCustomer,
};

export default RefundTransferService;
